export default __webpack_public_path__ + "static/media/landscape37.d905c295.jpeg";